import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    setSearchedLayer,
    setScrollingToSearchedLayer
} from '../../../../redux/panel/search_panel/Actions';

import { withStyles } from '@material-ui/core/styles';
import AdditionalLayerDropdownItem from './AdditonalLayerDropdownItem';

class AdditionalLayerDropdown extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            droppedDown: false,
            additionalLayersList: {}
        };

        this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    shouldComponentUpdate (nextProps, nextState) {
        return (
            this.props.allLayers != nextProps.allLayers ||
            this.state.droppedDown != nextState.droppedDown ||
            this.props.selectedLayer.systemName != nextProps.selectedLayer.systemName ||
            this.props.activeLayers != nextProps.activeLayers ||
            Object.keys(this.state.additionalLayersList).length !== Object.keys(nextState.additionalLayersList).length
        );
    }

    componentDidUpdate () {
        if (this.props.allLayers.length > 0 && Object.keys(this.state.additionalLayersList).length === 0) {
            this.setState({
                additionalLayersList: {
                    ...this.sortedLayers
                    // Planning: [
                    //     ...this.sortedLayers.Planning.filter(layer => !this.props.mainLayerNames.Planning.includes(layer.system_name))
                    // ],
                    // 'Property & Structures': [
                    //     ...this.sortedLayers['Property & Structures'].filter(layer => !this.props.mainLayerNames['Property & Structures'].includes(layer.system_name))
                    // ],
                    // 'Local Development Plans': [
                    //     ...this.sortedLayers['Local Development Plans'].filter(layer => !this.props.mainLayerNames['Local Development Plans'].includes(layer.system_name))
                    // ]
                }
            });
        }
    }

    sortedLayers = this.sortAllLayers(this.props.allLayers);

    sortAllLayers (layers) {
        let orderedLayers = {};
        for (const layer of layers) {
            orderedLayers[layer.group] = orderedLayers[layer.group] ? [...orderedLayers[layer.group], layer] : [layer];
        }
        return orderedLayers;
    }

    toggleDropdown (e) {
        const { selectedLayer, dispatchSetSearchedLayer } = this.props;
        const { additionalLayersList, droppedDown } = this.state;
        const containsLayer = additionalLayersList[selectedLayer.category] ?
            additionalLayersList[selectedLayer.category].find(l => l.system_name === selectedLayer.systemName) : false;
        if (containsLayer) {
            dispatchSetSearchedLayer({ category: '', systemName: '' });
            this.setState({
                droppedDown: false
            });
        } else {
            this.setState({
                droppedDown: !droppedDown
            });
        }
    }

    render () {
        const {
            classes,
            selectedLayer,
            additionalLayers
        } = this.props;
        const { droppedDown } = this.state;
        const containsLayer = additionalLayers[selectedLayer.category] ? additionalLayers[selectedLayer.category].find(l => l.system_name === selectedLayer.systemName) : false;

        const sortedCategories = Object.keys(additionalLayers).sort();
        return (
            <div className={classes.additionalLayersContainer}>
                { sortedCategories.map((category, i) => {
                    return additionalLayers[category].length > 0 && <AdditionalLayerDropdownItem group={category} layers={additionalLayers[category]} key={i} />;
                }
                )}
            </div>
        );
    }
}

const styles = (theme) => ({
    additionalLayersContainer: {
        borderRadius: '5px',
        border: `1px solid ${theme.palette.background.border}`,
        '&:hover': {
            // background: theme.palette.background.light
        }
    },
    additionalLayersContainerSelected: {
        // background: theme.palette.background.light
    },
    additionalLayersTitle: {
        color: '#c4c4c4',
        fontWeight: '600'
    },
    additionalLayersButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: '22px',
        paddingBottom: '16px',
        cursor: 'pointer',
        boxSizing: 'border-box'
    },
    additionalLayersButtonTitleText: {
        alignSelf: 'center',
        fontSize: '0.9rem'
    },
    additionalLayersButtonTitle: {
        paddingBottom: '5px',
        display: 'flex',
        gridColumnGap: '10px',
        alignItems: 'center'
    },
    additionalLayersButtonCheckbox: {
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center'
    },
    additionalLayersButtonCheckboxLabelContainer: {
        height: '11px',
        paddingBottom: '3px'
    },
    additionalLayersButtonCheckboxLabel: {
        fontSize: '0.6rem'
    },
    layerItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 5px 10px 15px'
    },
    layerItemTitleText: {
        // fontSize: '0.8rem'
    },
    addLayersToFavouriteButtonContainer: {
        padding: '20px 5px'
    },
    addLayersToFavouriteButton: {
        fontSize: '12px',
        width: '100%',
        padding: '8px'
    },
    groupContainer: {
        borderBottom: `1px solid ${theme.palette.background.border}`,
        paddingTop: '5px',
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    groupContainerSelected: {
        // background: theme.palette.background.lighter,
        // borderBottom: 'none'
    },
    groupItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 5px',
        cursor: 'pointer'
    },
    dropDownArrow: {
        alignSelf: 'center',
        transform: 'rotate(0deg)',
        transition: 'transform 0.2s linear',
        color: theme.palette.text.primary
    },
    dropDownArrowOpen: {
        transform: 'rotate(180deg)',
        transition: 'transform 0.2s linear'
    }
});

const mapStateToProps = (state) => {
    return {
        activeLayers: state.activeLayers,
        selectedLayer: state.search_panel.selectedLayer,
        allLayers: state.layers.layers,
        searchPanel: state.search_panel
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetSearchedLayer: ({ category, systemName }) => dispatch(setSearchedLayer({ category, systemName })),
        dispatchSetScrollingToSearchedLayer: (value) => dispatch(setScrollingToSearchedLayer(value))
    };
};

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(AdditionalLayerDropdown);